// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25825":"83f1c455f74e20837dca","51231":"8a8f135eaf142680d490"}[chunkId] + ".css";
};